export default Buffer.from("A+BSQ29weXJpZ2h0IDE5OTAtMjAwOSBBZG9iZSBTeXN0ZW1zIEluY29ycG9yYXRlZC4KQWxsIHJpZ2h0cyByZXNlcnZlZC4KU2VlIC4vTElDRU5TReELOTBwdi1SS1NKLUhhBYFBAb1PDQG9UQkCvVMCBL1WBBG9W0EVgYG9bYIdAAEAAQABAAEAGQAfAAEAAQAGAFMAAQABAAEAAQAZACAAAQABAAYAYQGDlQG+AnESh58AvgQAwQkAvgcAvgUAwQoBwQ0BwREAvgsBwRMAvgkAvgwAvhIBwRcAvg4BwRsAvg8AwR0AvhFhBoe9AMEeAADBIQAAwSQAAMEmAADBJTgCwQQ=", "base64")


//////////////////
// WEBPACK FOOTER
// ./~/vue-pdf-signature/src/buffer-loader.js!./~/pdfjs-dist-sign/cmaps/90pv-RKSJ-V.bcmap
// module id = 581
// module chunks = 502